/* eslint jsx-a11y/href-no-hash: "off" */
import React from "react";
import { connect } from "react-redux";
import EditCombatantNameField from "./EditCombatantNameField";
import EditCombatantAppearance from "./EditCombatantAppearance";
import EditCombatantLoadout from "./EditCombatantLoadout";
import { handleEditingDone } from "./edit-combatant-operations";

class EditCombatantModal extends React.Component {
  handleDoneClick(e) {
    e.preventDefault();
    handleEditingDone();
  }

  handleClose(e) {
    e.preventDefault();
    // console.log("TODO: close without saving");
    handleEditingDone();
  }

  getDesktopStyle() {
    const { vW } = this.props;
    return {
      maxWidth: vW * 60,
      fontSize: "0.5em",
      //padding: "3em",
      left: "50%",
      top: "50%",
      transform: "translate(-50%,-50%)"
    };
  }

  getMobileStyle() {
    return {
      fontSize: "0.65em",
      top: "2%",
      left: "2%",
      right: "2%"
    };
  }

  render() {
    const { viewportMode, editingCombatantProperties } = this.props;

    if (!editingCombatantProperties.isActivated) {
      console.warn(
        "Editing modal should not be mounted (but is). isActivated is not true"
      );
      return null;
    }

    const modalStyle = {
      margin: "0 auto",
      position: "absolute",
      left: "5%",
      right: "5%",
      borderLeft: "0.4em solid #200535",
      borderRight: "0.4em solid #200535",
      ...(viewportMode === "landscape"
        ? this.getDesktopStyle()
        : this.getMobileStyle())
    };

    return (
      <div className="ModalOverlay">
        <div className="Modal" style={modalStyle}>
          <div className="Modal--top-bar">
            <div>Edit Crew Member</div>
            <div>
              <a
                className="Modal--close"
                href="#"
                onClick={this.handleClose.bind(this)}
              >
                &times;
              </a>
            </div>
          </div>
          <div className="Modal--content-container">
            <EditCombatantNameField
              combatantName={editingCombatantProperties.combatantName}
            />
            <EditCombatantAppearance
              combatantSkin={editingCombatantProperties.combatantSkin}
            />
            <EditCombatantLoadout
              combatantLoadoutId={editingCombatantProperties.combatantLoadoutId}
            />

            <div>
              <a
                className="button block large"
                href="#"
                onClick={this.handleDoneClick.bind(this)}
              >
                <span className="button--text">Done Editing</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect((state, props) => {
  return {
    editingCombatantProperties: state.matchmaking.editingCombatantProperties,

    viewportMode: state.global.viewportMode,
    vW: state.global.vW
  };
})(EditCombatantModal);



// WEBPACK FOOTER //
// ./src/b5-crew-management/EditCombatantModal.js